<button type="button" class="live-bell" (click)="toggle($event)" aria-label="Notifications">
  <em class="icon-bell belcss"></em>
  <span class="badge sub-bell-badge" [ngClass]="'badge-' + badgeLevel" *ngIf="unread">{{ unread }}</span>
</button>
<div class="live-panel" *ngIf="open" (click)="$event.stopPropagation()">
  <div class="live-panel-head">
    <strong>Notifications</strong>
    <button type="button" class="live-text-btn" *ngIf="unread" (click)="markAll($event)">Mark all read</button>
  </div>
  <div class="live-empty" *ngIf="!items.length">No notifications yet.</div>
  <button type="button" class="live-item" *ngFor="let item of items" (click)="openItem(item)" [class.is-unread]="unreadItem(item)">
    <span class="live-title">{{ item.title }}</span>
    <span class="live-message">{{ item.message }}</span>
    <span class="live-time">{{ when(item.createdAt) }}</span>
  </button>
  <button type="button" class="live-view-all" *ngIf="audience === 'subscriber'" (click)="viewAll($event)">View all</button>
</div>
